import React from 'react';
import { Image } from 'antd';
import UiButton from '@components/ui/button/UiButton';
import UploadCvIcon from '@assets/svgs/upload-icon-black.svg';
import RightArrowIcon from '@assets/svgs/right-arrow-icon.svg';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import styles from './MainImage.module.scss';

type MainImageProps = {
  clientColor?: string;
  mainImage?: string;
  mainText?: string;
  setShowForm: (value: boolean) => void;
};

const MainImage: React.FC<MainImageProps> = ({ clientColor, mainImage, mainText, setShowForm }) => {
  const { t: translate } = useTranslation('form');
  const router = useRouter();

  return (
    <div className={styles.mainImageDesktopWrap}>
      <div className={styles.mainCardDesktopWrap}>
        <h2 className={styles.cardText}>{mainText || 'Κάνε το επόμενο βήμα στην καριέρα σου.'}</h2>
        <div className={styles.cardButtons}>
          <UiButton
            onClick={() => router.push(`#positions-section`)}
            type="primary"
            size="small"
            htmlType="submit"
            className={styles.showPositionsButton}
            icon={<RightArrowIcon />}
            style={{ backgroundColor: clientColor, borderColor: clientColor }}
          >
            {translate('openings')}
          </UiButton>
          <div style={{ backgroundColor: clientColor, borderRadius: '8px' }}>
            <UiButton
              onClick={() => {
                setShowForm(true);
                router.push(`#general-cv-section`);
              }}
              type="default"
              size="small"
              htmlType="submit"
              icon={<UploadCvIcon fill={clientColor || '#ff2458'} />}
              style={{ color: clientColor, borderColor: clientColor }}
              className={styles.cvButton}
            >
              {translate('cv')}
            </UiButton>
          </div>
        </div>
      </div>
      <Image
        src={mainImage || '/assets/images/client-images/default-main-image.jpeg'}
        alt="Company image"
        preview={false}
        className={styles.mainImage}
      />
    </div>
  );
};

MainImage.defaultProps = {
  clientColor: '',
  mainImage: '',
  mainText: '',
};

export default MainImage;
